import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { BookingCount } from '../../models/booking.count';

@Injectable()
export class BookingCountService {

    private subject = new Subject<BookingCount>();

    constructor() { }

    public setCount(type: string, count: number): void {
        this.subject.next({
            count: count,
            type: type
        });
    }

    public getCount(): Observable<BookingCount> {
        return this.subject.asObservable();
    }
}